pcstyle();
//监听屏幕改变resize事件 触发remChange方法
window.addEventListener("resize", pcstyle);
var scale=1;
export function pcstyle(){
  var doc = window.document;
  var docEl = doc.documentElement;
  var div = window.document.getElementsByClassName('pcstyle');
  var divnews=window.document.getElementsByClassName('pcnewsstyle');
  // console.log(docEl.getBoundingClientRect().width);
  // console.log(div.length)
  var width = docEl.getBoundingClientRect().width;
      scale=width / 1920;
      for (var i=0;i<div.length;i++) {
        div[i].setAttribute('style','transform: scale('+scale+') translateZ(0px);');
      }
      for (var i=0;i<divnews.length;i++) {
        divnews[i].setAttribute('style','zoom: '+scale);
      }
}

function remChange() {
	// var html = document.querySelector("html");
	// var width = html.getBoundingClientRect().width; //拿到适配器的宽度值
	// //若屏幕宽为375px则1rem = 100px 若不是则按比例增大或减小
	// html.style.fontSize = 375 / 3.75 + 'px';
  ;(function(win, lib) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      var flexibleEl = doc.querySelector('meta[name="flexible"]');
      var dpr = 0;
      var scale = 0;
      var tid;
      var flexible = lib.flexible || (lib.flexible = {});

      if (metaEl) {
          // console.warn('将根据已有的meta标签来设置缩放比例');
          var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
          if (match) {
              scale = parseFloat(match[1]);
              dpr = parseInt(1 / scale);
          }
      } else if (flexibleEl) {
          var content = flexibleEl.getAttribute('content');
          if (content) {
              var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
              var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
              if (initialDpr) {
                  dpr = parseFloat(initialDpr[1]);
                  scale = parseFloat((1 / dpr).toFixed(2));
              }
              if (maximumDpr) {
                  dpr = parseFloat(maximumDpr[1]);
                  scale = parseFloat((1 / dpr).toFixed(2));
              }
          }
      }

      if (!dpr && !scale) {
          var isAndroid = win.navigator.appVersion.match(/android/gi);
          var isIPhone = win.navigator.appVersion.match(/iphone/gi);
          var devicePixelRatio = win.devicePixelRatio;
          if (isIPhone) {
              // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
              if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                  dpr = 3;
              } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)){
                  dpr = 2;
              } else {
                  dpr = 1;
              }
          } else {
              // 其他设备下，仍旧使用1倍的方案
              dpr = 1;
          }
          scale = 1 / dpr;
      }

      docEl.setAttribute('data-dpr', dpr);
      if (!metaEl) {
          metaEl = doc.createElement('meta');
          metaEl.setAttribute('name', 'viewport');
          metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
          if (docEl.firstElementChild) {
              docEl.firstElementChild.appendChild(metaEl);
          } else {
              var wrap = doc.createElement('div');
              wrap.appendChild(metaEl);
              doc.write(wrap.innerHTML);
          }
      }

      function refreshRem(){
          var width = docEl.getBoundingClientRect().width;

          //设置max-width可去除注释

          /*if (width / dpr > 540) {
              width = 540 * dpr;
          }*/
          var rem = width / 10;
          docEl.style.fontSize = rem + 'px';
          flexible.rem = win.rem = rem;
      }

      win.addEventListener('resize', function() {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
      }, false);
      win.addEventListener('pageshow', function(e) {
          if (e.persisted) {
              clearTimeout(tid);
              tid = setTimeout(refreshRem, 300);
          }
      }, false);

      if (doc.readyState === 'complete') {
          doc.body.style.fontSize = 0.43 * dpr + 'rem';
      } else {
          doc.addEventListener('DOMContentLoaded', function(e) {
              doc.body.style.fontSize = 0.43 * dpr + 'rem';
          }, false);
      }


      refreshRem();

      flexible.dpr = win.dpr = dpr;
      flexible.refreshRem = refreshRem;
      flexible.rem2px = function(d) {
          var val = parseFloat(d) * this.rem;
          if (typeof d === 'string' && d.match(/rem$/)) {
              val += 'px';
          }
          return val;
      }
      flexible.px2rem = function(d) {
          var val = parseFloat(d) / this.rem;
          if (typeof d === 'string' && d.match(/px$/)) {
              val += 'rem';
          }
          return val;
      }

  })(window, window['lib'] || (window['lib'] = {}));
}
// 公共的js
//日期格式转换
export function FromDates(StringDate) {
    let T = "",
        N = "",
        Y = "",
        R = "";
    for (let i = 0; i < StringDate.length; i++) {
        N = StringDate.substring(0, 4) + "-";
        Y = StringDate.substring(4, 6) + "-";
        R = StringDate.substring(6, 8);
        T = N + Y + R;
        return T;
    }
}
//日期时间去横杠
export function FromDatesCancle(StringDate) {
    let CanTime = [];
    for (let i = 0; i < StringDate.length; i++) {
        if (StringDate[i] !== "-") {
            CanTime.push(StringDate[i]);
        }
    }
    return CanTime.join('');
}

export function toshowis(){
	console.log("is");
}


//排序
export function objKeySort(obj) {
    var newkey = Object.keys(obj).sort();
    var newObj = {};
    for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]];
    }
    return newObj;
}

//拼接
export function genSign(obj,apikey){
//	console.log(obj);
    if (obj.sign) {
        delete obj.sign;
    }
    var str = "";
    var newkey = Object.keys(obj);
    for(var i = 0; i< newkey.length; i++)
    {
        str += newkey[i]+'='+obj[newkey[i]];
    }
    str += apikey;
    return str;
}
